import { AdminProposalSummary } from './adminTypes'

export const adminProposals: AdminProposalSummary[] = [
  {
    id: '1',
    title: "NIH R01: Neural Mechanisms of Alzheimer's Disease Progression",
    funder: 'NIH / NIA',
    mechanism: 'R01',
    piName: 'Dr. Sarah Chen',
    department: 'Neuroscience',
    status: 'In Progress',
    riskStatus: 'at-risk',
    deadline: 'Mar 5, 2026',
    deadlineISO: '2026-03-05',
    maxBudget: '$2,500,000',
    grantLength: '5 years',
    artifactsCompleted: 9,
    artifactsTotal: 19,
    criteriaSatisfied: 8,
    criteriaTotal: 13,
    aiCheckStatus: 'issues',
    aiIssueCount: 4,
    overdueTasks: 2,
    openTasks: 4,
    totalTasks: 8,
    lastActivity: 'PI uploaded Research Strategy draft',
    lastActivityTime: '2h ago',
    team: [
      { initials: 'SC', color: 'bg-indigo-100 text-indigo-700' },
      { initials: 'MS', color: 'bg-emerald-100 text-emerald-700' },
      { initials: 'JP', color: 'bg-amber-100 text-amber-700' },
    ],
  },
  {
    id: '2',
    title: 'NSF CAREER: Quantum Computing Education for High Schools',
    funder: 'NSF',
    mechanism: 'CAREER',
    piName: 'Dr. Sarah Chen',
    department: 'Computer Science',
    status: 'Submitted',
    riskStatus: 'on-track',
    deadline: 'Feb 15, 2026',
    deadlineISO: '2026-02-15',
    maxBudget: '$800,000',
    grantLength: '5 years',
    artifactsCompleted: 14,
    artifactsTotal: 14,
    criteriaSatisfied: 9,
    criteriaTotal: 9,
    aiCheckStatus: 'all-passed',
    aiIssueCount: 0,
    overdueTasks: 0,
    openTasks: 0,
    totalTasks: 12,
    lastActivity: 'Submitted via Research.gov',
    lastActivityTime: '3d ago',
    team: [
      { initials: 'SC', color: 'bg-indigo-100 text-indigo-700' },
      { initials: 'AL', color: 'bg-blue-100 text-blue-700' },
    ],
  },
  {
    id: '3',
    title: 'Gates Foundation: Equitable Access to mRNA Vaccine Manufacturing',
    funder: 'Gates Foundation',
    mechanism: 'Grand Challenges',
    piName: 'Dr. Sarah Chen',
    department: 'Bioengineering',
    status: 'In Progress',
    riskStatus: 'on-track',
    deadline: 'Jun 15, 2026',
    deadlineISO: '2026-06-15',
    maxBudget: '$5,000,000',
    grantLength: '3 years',
    artifactsCompleted: 12,
    artifactsTotal: 15,
    criteriaSatisfied: 10,
    criteriaTotal: 11,
    aiCheckStatus: 'partial',
    aiIssueCount: 1,
    overdueTasks: 0,
    openTasks: 2,
    totalTasks: 10,
    lastActivity: 'Co-I uploaded budget justification',
    lastActivityTime: '1d ago',
    team: [
      { initials: 'SC', color: 'bg-indigo-100 text-indigo-700' },
      { initials: 'RK', color: 'bg-rose-100 text-rose-700' },
      { initials: 'TY', color: 'bg-cyan-100 text-cyan-700' },
    ],
  },
  {
    id: '4',
    title: "NIH R21: Gut Microbiome Signatures in Early-Onset Parkinson's",
    funder: 'NIH / NINDS',
    mechanism: 'R21',
    piName: 'Dr. Marcus Rivera',
    department: 'Neurology',
    status: 'In Progress',
    riskStatus: 'needs-attention',
    deadline: 'Apr 12, 2026',
    deadlineISO: '2026-04-12',
    maxBudget: '$275,000',
    grantLength: '2 years',
    artifactsCompleted: 5,
    artifactsTotal: 12,
    criteriaSatisfied: 4,
    criteriaTotal: 8,
    aiCheckStatus: 'issues',
    aiIssueCount: 2,
    overdueTasks: 1,
    openTasks: 3,
    totalTasks: 7,
    lastActivity: 'AI flagged biosketch format issue',
    lastActivityTime: '4h ago',
    team: [
      { initials: 'MR', color: 'bg-violet-100 text-violet-700' },
      { initials: 'LW', color: 'bg-pink-100 text-pink-700' },
    ],
  },
  {
    id: '5',
    title:
      'DOE: Next-Gen Perovskite Solar Cell Stability Under Field Conditions',
    funder: 'DOE / EERE',
    mechanism: 'FOA',
    piName: 'Dr. Priya Patel',
    department: 'Materials Science',
    status: 'In Progress',
    riskStatus: 'on-track',
    deadline: 'May 1, 2026',
    deadlineISO: '2026-05-01',
    maxBudget: '$1,200,000',
    grantLength: '3 years',
    artifactsCompleted: 8,
    artifactsTotal: 11,
    criteriaSatisfied: 7,
    criteriaTotal: 9,
    aiCheckStatus: 'partial',
    aiIssueCount: 1,
    overdueTasks: 0,
    openTasks: 2,
    totalTasks: 9,
    lastActivity: 'Budget approved by department chair',
    lastActivityTime: '6h ago',
    team: [
      { initials: 'PP', color: 'bg-orange-100 text-orange-700' },
      { initials: 'KN', color: 'bg-teal-100 text-teal-700' },
      { initials: 'DL', color: 'bg-slate-100 text-slate-700' },
    ],
  },
  {
    id: '6',
    title: 'NSF Standard: Distributed Algorithms for Edge Computing Networks',
    funder: 'NSF / CISE',
    mechanism: 'Standard Grant',
    piName: 'Dr. Wei Zhang',
    department: 'Computer Science',
    status: 'Draft',
    riskStatus: 'needs-attention',
    deadline: 'Mar 20, 2026',
    deadlineISO: '2026-03-20',
    maxBudget: '$600,000',
    grantLength: '3 years',
    artifactsCompleted: 2,
    artifactsTotal: 14,
    criteriaSatisfied: 1,
    criteriaTotal: 10,
    aiCheckStatus: 'not-checked',
    aiIssueCount: 0,
    overdueTasks: 0,
    openTasks: 6,
    totalTasks: 6,
    lastActivity: 'PI created workspace',
    lastActivityTime: '2d ago',
    team: [{ initials: 'WZ', color: 'bg-sky-100 text-sky-700' }],
  },
  {
    id: '7',
    title:
      'Wellcome Trust: Antimicrobial Resistance Surveillance in Sub-Saharan Africa',
    funder: 'Wellcome Trust',
    mechanism: 'Discovery Award',
    piName: 'Dr. Amara Osei',
    department: 'Global Health',
    status: 'In Progress',
    riskStatus: 'on-track',
    deadline: 'Jul 30, 2026',
    deadlineISO: '2026-07-30',
    maxBudget: '$3,500,000',
    grantLength: '5 years',
    artifactsCompleted: 6,
    artifactsTotal: 10,
    criteriaSatisfied: 5,
    criteriaTotal: 7,
    aiCheckStatus: 'all-passed',
    aiIssueCount: 0,
    overdueTasks: 0,
    openTasks: 1,
    totalTasks: 5,
    lastActivity: 'Letters of support uploaded',
    lastActivityTime: '1d ago',
    team: [
      { initials: 'AO', color: 'bg-emerald-100 text-emerald-700' },
      { initials: 'BT', color: 'bg-amber-100 text-amber-700' },
    ],
  },
  {
    id: '8',
    title: 'DOD CDMRP: Traumatic Brain Injury Biomarker Discovery Program',
    funder: 'DOD / CDMRP',
    mechanism: 'W81XWH',
    piName: 'Dr. James Park',
    department: 'Neuroscience',
    status: 'In Progress',
    riskStatus: 'at-risk',
    deadline: 'Feb 28, 2026',
    deadlineISO: '2026-02-28',
    maxBudget: '$450,000',
    grantLength: '2 years',
    artifactsCompleted: 7,
    artifactsTotal: 16,
    criteriaSatisfied: 5,
    criteriaTotal: 11,
    aiCheckStatus: 'issues',
    aiIssueCount: 3,
    overdueTasks: 3,
    openTasks: 5,
    totalTasks: 11,
    lastActivity: 'AI detected missing HRPO approval',
    lastActivityTime: '30m ago',
    team: [
      { initials: 'JP', color: 'bg-amber-100 text-amber-700' },
      { initials: 'SC', color: 'bg-indigo-100 text-indigo-700' },
      { initials: 'RT', color: 'bg-red-100 text-red-700' },
    ],
  },
  {
    id: '9',
    title: 'NIH K99/R00: Epigenetic Regulation of Immune Cell Differentiation',
    funder: 'NIH / NIAID',
    mechanism: 'K99/R00',
    piName: 'Dr. Elena Vasquez',
    department: 'Immunology',
    status: 'In Progress',
    riskStatus: 'on-track',
    deadline: 'Apr 8, 2026',
    deadlineISO: '2026-04-08',
    maxBudget: '$999,000',
    grantLength: '5 years',
    artifactsCompleted: 10,
    artifactsTotal: 13,
    criteriaSatisfied: 8,
    criteriaTotal: 10,
    aiCheckStatus: 'partial',
    aiIssueCount: 1,
    overdueTasks: 0,
    openTasks: 2,
    totalTasks: 8,
    lastActivity: 'Mentor letter finalized',
    lastActivityTime: '5h ago',
    team: [
      { initials: 'EV', color: 'bg-fuchsia-100 text-fuchsia-700' },
      { initials: 'DR', color: 'bg-lime-100 text-lime-700' },
    ],
  },
  {
    id: '10',
    title:
      'Simons Foundation: Mathematical Foundations of Deep Learning Generalization',
    funder: 'Simons Foundation',
    mechanism: 'Investigator Award',
    piName: 'Dr. Wei Zhang',
    department: 'Mathematics',
    status: 'Submitted',
    riskStatus: 'on-track',
    deadline: 'Jan 15, 2026',
    deadlineISO: '2026-01-15',
    maxBudget: '$1,000,000',
    grantLength: '5 years',
    artifactsCompleted: 8,
    artifactsTotal: 8,
    criteriaSatisfied: 6,
    criteriaTotal: 6,
    aiCheckStatus: 'all-passed',
    aiIssueCount: 0,
    overdueTasks: 0,
    openTasks: 0,
    totalTasks: 6,
    lastActivity: 'Application submitted',
    lastActivityTime: '1w ago',
    team: [{ initials: 'WZ', color: 'bg-sky-100 text-sky-700' }],
  },
  {
    id: '11',
    title: 'USDA NIFA: Climate-Resilient Cover Crop Systems for the Midwest',
    funder: 'USDA / NIFA',
    mechanism: 'AFRI',
    piName: 'Dr. Rachel Thompson',
    department: 'Agricultural Sciences',
    status: 'In Progress',
    riskStatus: 'needs-attention',
    deadline: 'Mar 30, 2026',
    deadlineISO: '2026-03-30',
    maxBudget: '$750,000',
    grantLength: '4 years',
    artifactsCompleted: 4,
    artifactsTotal: 11,
    criteriaSatisfied: 3,
    criteriaTotal: 8,
    aiCheckStatus: 'issues',
    aiIssueCount: 2,
    overdueTasks: 1,
    openTasks: 4,
    totalTasks: 7,
    lastActivity: 'Collaborator added from Iowa State',
    lastActivityTime: '3h ago',
    team: [
      { initials: 'RT', color: 'bg-green-100 text-green-700' },
      { initials: 'MJ', color: 'bg-yellow-100 text-yellow-700' },
      { initials: 'KP', color: 'bg-blue-100 text-blue-700' },
    ],
  },
  {
    id: '12',
    title:
      'NIH U01: Multi-Site Longitudinal Study of Vascular Cognitive Impairment',
    funder: 'NIH / NIA',
    mechanism: 'U01',
    piName: 'Dr. Marcus Rivera',
    department: 'Neurology',
    status: 'In Progress',
    riskStatus: 'on-track',
    deadline: 'May 15, 2026',
    deadlineISO: '2026-05-15',
    maxBudget: '$6,200,000',
    grantLength: '5 years',
    artifactsCompleted: 14,
    artifactsTotal: 22,
    criteriaSatisfied: 11,
    criteriaTotal: 15,
    aiCheckStatus: 'partial',
    aiIssueCount: 2,
    overdueTasks: 0,
    openTasks: 3,
    totalTasks: 14,
    lastActivity: 'Subcontract from Johns Hopkins received',
    lastActivityTime: '8h ago',
    team: [
      { initials: 'MR', color: 'bg-violet-100 text-violet-700' },
      { initials: 'SC', color: 'bg-indigo-100 text-indigo-700' },
      { initials: 'AK', color: 'bg-rose-100 text-rose-700' },
      { initials: 'TL', color: 'bg-cyan-100 text-cyan-700' },
    ],
  },
  {
    id: '13',
    title: 'HHMI: Emerging Pathogens Preparedness — Rapid Diagnostics Platform',
    funder: 'HHMI',
    mechanism: 'Faculty Scholar',
    piName: 'Dr. Amara Osei',
    department: 'Molecular Biology',
    status: 'Draft',
    riskStatus: 'needs-attention',
    deadline: 'Jun 1, 2026',
    deadlineISO: '2026-06-01',
    maxBudget: '$1,500,000',
    grantLength: '5 years',
    artifactsCompleted: 1,
    artifactsTotal: 9,
    criteriaSatisfied: 0,
    criteriaTotal: 7,
    aiCheckStatus: 'not-checked',
    aiIssueCount: 0,
    overdueTasks: 0,
    openTasks: 2,
    totalTasks: 2,
    lastActivity: 'PI started specific aims draft',
    lastActivityTime: '1d ago',
    team: [{ initials: 'AO', color: 'bg-emerald-100 text-emerald-700' }],
  },
  {
    id: '14',
    title:
      'NIH P01: Integrated Approaches to Pancreatic Cancer Early Detection',
    funder: 'NIH / NCI',
    mechanism: 'P01',
    piName: 'Dr. Linda Nakamura',
    department: 'Oncology',
    status: 'In Progress',
    riskStatus: 'at-risk',
    deadline: 'Mar 1, 2026',
    deadlineISO: '2026-03-01',
    maxBudget: '$8,750,000',
    grantLength: '5 years',
    artifactsCompleted: 11,
    artifactsTotal: 28,
    criteriaSatisfied: 9,
    criteriaTotal: 18,
    aiCheckStatus: 'issues',
    aiIssueCount: 5,
    overdueTasks: 2,
    openTasks: 7,
    totalTasks: 18,
    lastActivity: 'Core B budget revision submitted',
    lastActivityTime: '1h ago',
    team: [
      { initials: 'LN', color: 'bg-pink-100 text-pink-700' },
      { initials: 'SC', color: 'bg-indigo-100 text-indigo-700' },
      { initials: 'JP', color: 'bg-amber-100 text-amber-700' },
      { initials: 'MR', color: 'bg-violet-100 text-violet-700' },
      { initials: 'KS', color: 'bg-teal-100 text-teal-700' },
    ],
  },
  {
    id: '15',
    title:
      'Keck Foundation: Novel Imaging Modalities for Deep Brain Structures',
    funder: 'W.M. Keck Foundation',
    mechanism: 'Research Grant',
    piName: 'Dr. Priya Patel',
    department: 'Chemistry',
    status: 'Needs Review',
    riskStatus: 'on-track',
    deadline: 'Apr 15, 2026',
    deadlineISO: '2026-04-15',
    maxBudget: '$1,000,000',
    grantLength: '3 years',
    artifactsCompleted: 10,
    artifactsTotal: 10,
    criteriaSatisfied: 7,
    criteriaTotal: 7,
    aiCheckStatus: 'all-passed',
    aiIssueCount: 0,
    overdueTasks: 0,
    openTasks: 0,
    totalTasks: 8,
    lastActivity: 'All artifacts complete — ready for admin review',
    lastActivityTime: '1d ago',
    team: [
      { initials: 'PP', color: 'bg-orange-100 text-orange-700' },
      { initials: 'JP', color: 'bg-amber-100 text-amber-700' },
    ],
  },
  {
    id: '16',
    title: 'NIH R01: Cardiac Fibrosis Reversal via Targeted RNA Therapeutics',
    funder: 'NIH / NHLBI',
    mechanism: 'R01',
    piName: 'Dr. Elena Vasquez',
    department: 'Cardiology',
    status: 'In Progress',
    riskStatus: 'on-track',
    deadline: 'May 7, 2026',
    deadlineISO: '2026-05-07',
    maxBudget: '$2,250,000',
    grantLength: '5 years',
    artifactsCompleted: 11,
    artifactsTotal: 17,
    criteriaSatisfied: 9,
    criteriaTotal: 12,
    aiCheckStatus: 'partial',
    aiIssueCount: 1,
    overdueTasks: 0,
    openTasks: 3,
    totalTasks: 10,
    lastActivity: 'Research Strategy revised per mentor feedback',
    lastActivityTime: '3h ago',
    team: [
      { initials: 'EV', color: 'bg-fuchsia-100 text-fuchsia-700' },
      { initials: 'SC', color: 'bg-indigo-100 text-indigo-700' },
      { initials: 'NH', color: 'bg-sky-100 text-sky-700' },
    ],
  },
  {
    id: '17',
    title:
      'NASA ROSES: Radiation Shielding Composites for Lunar Habitat Structures',
    funder: 'NASA',
    mechanism: 'ROSES',
    piName: 'Dr. Priya Patel',
    department: 'Aerospace Engineering',
    status: 'In Progress',
    riskStatus: 'needs-attention',
    deadline: 'Apr 20, 2026',
    deadlineISO: '2026-04-20',
    maxBudget: '$900,000',
    grantLength: '3 years',
    artifactsCompleted: 6,
    artifactsTotal: 13,
    criteriaSatisfied: 4,
    criteriaTotal: 9,
    aiCheckStatus: 'issues',
    aiIssueCount: 2,
    overdueTasks: 1,
    openTasks: 4,
    totalTasks: 9,
    lastActivity: 'NASA TechPort registration pending',
    lastActivityTime: '12h ago',
    team: [
      { initials: 'PP', color: 'bg-orange-100 text-orange-700' },
      { initials: 'RG', color: 'bg-slate-100 text-slate-700' },
    ],
  },
  {
    id: '18',
    title:
      'AHA: Disparities in Post-Stroke Cognitive Recovery Among Rural Populations',
    funder: 'American Heart Association',
    mechanism: 'Innovative Project Award',
    piName: 'Dr. Marcus Rivera',
    department: 'Neurology',
    status: 'Submitted',
    riskStatus: 'on-track',
    deadline: 'Jan 29, 2026',
    deadlineISO: '2026-01-29',
    maxBudget: '$200,000',
    grantLength: '2 years',
    artifactsCompleted: 11,
    artifactsTotal: 11,
    criteriaSatisfied: 8,
    criteriaTotal: 8,
    aiCheckStatus: 'all-passed',
    aiIssueCount: 0,
    overdueTasks: 0,
    openTasks: 0,
    totalTasks: 9,
    lastActivity: 'Submitted via ProposalCentral',
    lastActivityTime: '5d ago',
    team: [
      { initials: 'MR', color: 'bg-violet-100 text-violet-700' },
      { initials: 'KW', color: 'bg-green-100 text-green-700' },
    ],
  },
  {
    id: '19',
    title: 'NIH R21: Digital Phenotyping for Adolescent Depression Screening',
    funder: 'NIH / NIMH',
    mechanism: 'R21',
    piName: 'Dr. David Kim',
    department: 'Psychology',
    status: 'Draft',
    riskStatus: 'needs-attention',
    deadline: 'Apr 16, 2026',
    deadlineISO: '2026-04-16',
    maxBudget: '$275,000',
    grantLength: '2 years',
    artifactsCompleted: 3,
    artifactsTotal: 12,
    criteriaSatisfied: 2,
    criteriaTotal: 9,
    aiCheckStatus: 'not-checked',
    aiIssueCount: 0,
    overdueTasks: 0,
    openTasks: 5,
    totalTasks: 5,
    lastActivity: 'Specific Aims page drafted',
    lastActivityTime: '1d ago',
    team: [{ initials: 'DK', color: 'bg-blue-100 text-blue-700' }],
  },
  {
    id: '20',
    title:
      'EPA STAR: PFAS Remediation in Municipal Water Systems Using Biochar',
    funder: 'EPA',
    mechanism: 'STAR Grant',
    piName: 'Dr. Rachel Thompson',
    department: 'Environmental Science',
    status: 'In Progress',
    riskStatus: 'on-track',
    deadline: 'Jun 30, 2026',
    deadlineISO: '2026-06-30',
    maxBudget: '$500,000',
    grantLength: '3 years',
    artifactsCompleted: 7,
    artifactsTotal: 10,
    criteriaSatisfied: 6,
    criteriaTotal: 8,
    aiCheckStatus: 'all-passed',
    aiIssueCount: 0,
    overdueTasks: 0,
    openTasks: 1,
    totalTasks: 6,
    lastActivity: 'QAPP document uploaded',
    lastActivityTime: '2d ago',
    team: [
      { initials: 'RT', color: 'bg-green-100 text-green-700' },
      { initials: 'JM', color: 'bg-amber-100 text-amber-700' },
      { initials: 'SL', color: 'bg-teal-100 text-teal-700' },
    ],
  },
  {
    id: '21',
    title: 'Moore Foundation: Deep-Sea Hydrothermal Vent Ecosystem Genomics',
    funder: 'Gordon & Betty Moore Foundation',
    mechanism: 'Marine Microbiology Initiative',
    piName: 'Dr. Sofia Andersson',
    department: 'Marine Biology',
    status: 'In Progress',
    riskStatus: 'at-risk',
    deadline: 'Mar 10, 2026',
    deadlineISO: '2026-03-10',
    maxBudget: '$350,000',
    grantLength: '2 years',
    artifactsCompleted: 4,
    artifactsTotal: 12,
    criteriaSatisfied: 3,
    criteriaTotal: 8,
    aiCheckStatus: 'issues',
    aiIssueCount: 3,
    overdueTasks: 2,
    openTasks: 5,
    totalTasks: 8,
    lastActivity: 'AI flagged missing data management plan',
    lastActivityTime: '1h ago',
    team: [
      { initials: 'SA', color: 'bg-cyan-100 text-cyan-700' },
      { initials: 'MR', color: 'bg-violet-100 text-violet-700' },
    ],
  },
  {
    id: '22',
    title:
      'NIH F31: Microglial Dynamics in Neurodegeneration — Predoctoral Fellowship',
    funder: 'NIH / NINDS',
    mechanism: 'F31',
    piName: 'Maya Johnson',
    department: 'Neuroscience',
    status: 'In Progress',
    riskStatus: 'on-track',
    deadline: 'Apr 8, 2026',
    deadlineISO: '2026-04-08',
    maxBudget: '$180,000',
    grantLength: '3 years',
    artifactsCompleted: 8,
    artifactsTotal: 11,
    criteriaSatisfied: 7,
    criteriaTotal: 9,
    aiCheckStatus: 'partial',
    aiIssueCount: 1,
    overdueTasks: 0,
    openTasks: 2,
    totalTasks: 7,
    lastActivity: 'Sponsor letter uploaded by Dr. Chen',
    lastActivityTime: '4h ago',
    team: [
      { initials: 'MJ', color: 'bg-yellow-100 text-yellow-700' },
      { initials: 'SC', color: 'bg-indigo-100 text-indigo-700' },
    ],
  },
  {
    id: '23',
    title: 'Arnold Ventures: Evidence-Based Bail Reform Impact Evaluation',
    funder: 'Arnold Ventures',
    mechanism: 'Research Grant',
    piName: 'Dr. Robert Hayes',
    department: 'Public Policy',
    status: 'Draft',
    riskStatus: 'needs-attention',
    deadline: 'May 30, 2026',
    deadlineISO: '2026-05-30',
    maxBudget: '$400,000',
    grantLength: '2 years',
    artifactsCompleted: 1,
    artifactsTotal: 8,
    criteriaSatisfied: 0,
    criteriaTotal: 6,
    aiCheckStatus: 'not-checked',
    aiIssueCount: 0,
    overdueTasks: 0,
    openTasks: 3,
    totalTasks: 3,
    lastActivity: 'PI created workspace and uploaded LOI',
    lastActivityTime: '3d ago',
    team: [{ initials: 'RH', color: 'bg-slate-100 text-slate-700' }],
  },
  {
    id: '24',
    title:
      'NSF Collaborative: Topological Quantum Materials for Fault-Tolerant Computing',
    funder: 'NSF / MPS',
    mechanism: 'Collaborative Research',
    piName: 'Dr. Wei Zhang',
    department: 'Physics',
    status: 'In Progress',
    riskStatus: 'on-track',
    deadline: 'Jun 10, 2026',
    deadlineISO: '2026-06-10',
    maxBudget: '$1,400,000',
    grantLength: '4 years',
    artifactsCompleted: 9,
    artifactsTotal: 14,
    criteriaSatisfied: 7,
    criteriaTotal: 10,
    aiCheckStatus: 'partial',
    aiIssueCount: 1,
    overdueTasks: 0,
    openTasks: 2,
    totalTasks: 8,
    lastActivity: 'Collaboration plan finalized with MIT',
    lastActivityTime: '6h ago',
    team: [
      { initials: 'WZ', color: 'bg-sky-100 text-sky-700' },
      { initials: 'PP', color: 'bg-orange-100 text-orange-700' },
      { initials: 'AL', color: 'bg-blue-100 text-blue-700' },
    ],
  },
  {
    id: '25',
    title:
      'NIH R01: Islet Cell Regeneration in Type 1 Diabetes via Small Molecules',
    funder: 'NIH / NIDDK',
    mechanism: 'R01',
    piName: 'Dr. Kenji Tanaka',
    department: 'Endocrinology',
    status: 'Submitted',
    riskStatus: 'on-track',
    deadline: 'Feb 5, 2026',
    deadlineISO: '2026-02-05',
    maxBudget: '$2,500,000',
    grantLength: '5 years',
    artifactsCompleted: 18,
    artifactsTotal: 18,
    criteriaSatisfied: 12,
    criteriaTotal: 12,
    aiCheckStatus: 'all-passed',
    aiIssueCount: 0,
    overdueTasks: 0,
    openTasks: 0,
    totalTasks: 11,
    lastActivity: 'Submitted via Grants.gov',
    lastActivityTime: '1w ago',
    team: [
      { initials: 'KT', color: 'bg-red-100 text-red-700' },
      { initials: 'LN', color: 'bg-pink-100 text-pink-700' },
      { initials: 'SC', color: 'bg-indigo-100 text-indigo-700' },
    ],
  },
  {
    id: '26',
    title:
      'Packard Foundation: Catalytic Conversion of CO₂ to Sustainable Aviation Fuel',
    funder: 'David & Lucile Packard Foundation',
    mechanism: 'Fellowship',
    piName: 'Dr. Priya Patel',
    department: 'Chemistry',
    status: 'Needs Review',
    riskStatus: 'on-track',
    deadline: 'May 1, 2026',
    deadlineISO: '2026-05-01',
    maxBudget: '$875,000',
    grantLength: '3 years',
    artifactsCompleted: 7,
    artifactsTotal: 7,
    criteriaSatisfied: 5,
    criteriaTotal: 5,
    aiCheckStatus: 'all-passed',
    aiIssueCount: 0,
    overdueTasks: 0,
    openTasks: 0,
    totalTasks: 5,
    lastActivity: 'All artifacts complete — ready for admin review',
    lastActivityTime: '2d ago',
    team: [{ initials: 'PP', color: 'bg-orange-100 text-orange-700' }],
  },
]
